/* Component Dependencies */
var connectionPortalTriggerTemplate = require('templates/connectionPortalTrigger.hbs');
var AriesComponent = require('libs/aries-component');
var Popup = require('libs/popup');

AriesComponent.create({
  type: 'connectionPortalTrigger',
  template: {
    'connectionPortalTrigger': connectionPortalTriggerTemplate
  },
  unBindEvents: function($) {
    $('*[data-component-id="' + this.$el.data('component-id') + '"]').off();
    $('*[data-component-id="' + this.$el.data('component-id') + '"] *').off();
  },
  bindEvents: function() {
    if (this.$el.data('showpopup')) {
      var connectionPortalPopup = new Popup({
        url: this.$el.data('popupurl'),
        open: true, 
        alternateCloseMarkup: true,
        sourceBlock: '.modal-content',
        closeOnBgClick: false
      });
      connectionPortalPopup.register();
    }
  }
});
